import { Injectable } from '@angular/core';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { Subject } from 'rxjs';

export interface SaveMapParams {
	handler: AnyHandler;
	map: ISLMap;
}

@Injectable({
	providedIn: 'root'
})
export class SaveMapDialogService {
	public request$: Subject<SaveMapParams> = new Subject();
	constructor() { }


	Show(handler: AnyHandler, map: ISLMap) {
		this.request$.next({
			handler: (handler),
			map: (map)
		});

	}
}
